export default {
  styleOverrides: {
    root: {
      "& .MuiRating-icon": {
        paddingRight: 5,
      },
    },
  },
  variants: [
    {
      props: { size: "xsmall" },
      style: {
        "& .MuiRating-icon .MuiSvgIcon-root": {
          fontSize: 16,
        },
      },
    },
  ],
};
